import { getScaleArray } from 'core/utils/parses';
import { getStudentDisplayName } from 'core/utils/user';

type GradedStudent = { lastName?: string; lastname?: string; name?: string };
type GroupedStudents = Record<string, GradedStudent[] | undefined>;
type Translate = (key: string, options: Record<string, unknown>) => string;

export type GradeDistributionItem = { grade: string; label: string };

/** Alternativa textual del gráfico de barras por nota: cuántos alumnos hay en cada nota de la escala y quiénes. */
export function getGradeDistributionItems(
  groupedStudents: GroupedStudents | GradedStudent[] | null | undefined,
  scoreScale: number | string | undefined,
  t: Translate
): GradeDistributionItem[] {
  // VerticalStudentsResults arranca con [] hasta que agrupa a los alumnos
  const groups: GroupedStudents = Array.isArray(groupedStudents) ? {} : (groupedStudents ?? {});

  return getScaleArray(scoreScale).map((scaleGrade: number | string) => {
    const grade = String(scaleGrade);
    const students = groups[grade] ?? [];
    const count = students.length;

    if (count === 0) {
      return { grade, label: t('lesson:Grade x with x students', { count, grade }) };
    }

    const names = students.map((student) => getStudentDisplayName(student.name, student.lastName, false, student.lastname)).join(', ');
    return { grade, label: t('lesson:Grade x with x students and names', { count, grade, names }) };
  });
}
